import { render, staticRenderFns } from "./TextElementSettings.vue?vue&type=template&id=59e5b3bd&scoped=true&"
import script from "./TextElementSettings.vue?vue&type=script&lang=ts&"
export * from "./TextElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e5b3bd",
  null
  
)

export default component.exports